import React, { useContext, useEffect, useState } from "react";
import BaseModal from "../../components/BaseModal";
import { useTranslation } from "react-i18next";
import BaseButton from "../../components/BaseButton";
import useModalActions from "../../hooks/useModalActions";
import { SOCKET_EVENTS, SocketContext } from "../../components/SocketProvider";
import { useLocation, useNavigate } from "react-router-dom";
import "./style.scss";
import Game from "../../store/Game";
import ROUTES from "../../utils/routes";
import { COUNT_CARDS } from "../../utils/constants";
import PersonalAccount from "../../store/PersonalAccount";
import useCurrentGame from "../../hooks/useCurrentGame";

export default function EndGameModal({ modalType, title }) {
  const { t } = useTranslation();
  const { socket } = useContext(SocketContext);
  const { openModal, closeModal } = useModalActions();
  const navigate = useNavigate();
  const location = useLocation();
  const { setGame } = useCurrentGame();
  const [currentGame, setCurrentGame] = useState(null);

  const onMessage = async ({ gameId, senderId, isEnd }) => {
    console.log(gameId, senderId, isEnd);
    const foundGame = PersonalAccount.games.find((game) => game.id === gameId);
    if (
      foundGame && foundGame.partner && senderId === foundGame.partner.id &&
      foundGame?.answers?.length === COUNT_CARDS
    ) {
      Game.getAllGamesMatches();
      setCurrentGame(foundGame);
      if (location.pathname !== ROUTES.END_GAME_PAGE) {
        openModal(modalType);
      }
    }

    // const game = Game.game;
    // if (senderId === game.partner.id && game?.answers?.length === COUNT_CARDS) {
    //   Game.getAllGamesMatches();
    //   const foundGame = PersonalAccount.games.find(
    //     (game) => game.id === gameId
    //   );
    //   setCurrentGame(foundGame);
    //   if (location.pathname !== ROUTES.END_GAME_PAGE) {
    //     openModal(modalType);
    //   }
    // }
  };
  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.END_GAME_MESSAGE, onMessage);
    return () => {
      socket.current.off(SOCKET_EVENTS.END_GAME_MESSAGE, onMessage);
    };
  }, [socket]);

  const onNext = async () => {
    if (location.pathname !== ROUTES.MATCHES_PAGE) {
      setGame(currentGame);
      Game.setGame(currentGame);

      await PersonalAccount.getPersonalAccountData();
      if (!PersonalAccount.user.gameIdsByRules.includes(currentGame.id)) {
        navigate(ROUTES.ACCEPT_RULES_PAGE);
        closeModal(modalType);
        return;
      }
      navigate(ROUTES.MATCHES_PAGE);
    }
    closeModal(modalType);
  };

  return (
    <BaseModal
      className="end-game-modal"
      contentStyle="end-game-modal__content"
      descriptionStyle="end-game-modal__description"
      description={
        <div className="end-game-modal__description-container">{title}</div>
      }
      eventTypeModal={modalType}
    >
      <BaseButton onClick={onNext}>
        {t("modals.insight_form_invite_partner.watch")}
      </BaseButton>
    </BaseModal>
  );
}
